import { createFileRoute, redirect } from "@tanstack/react-router";
import { isValidLocale } from "../../lib/i18n";

/** /fr/login is what people type: 301 to /fr/sign-in, language and query kept. */
export const Route = createFileRoute("/$lang/login")({
  beforeLoad: ({ params, location }) => {
    const target = isValidLocale(params.lang) ? `/${params.lang}/sign-in` : "/sign-in";
    throw redirect({ href: `${target}${location.searchStr}`, statusCode: 301 });
  },
});
